import axios from "axios";
import html2canvas from "html2canvas";
import MaterialIcon from "material-icons-react";
import React from "react";
import { Table } from "react-materialize";
import "./ImpressaoPropostaPage.css";
import LogotipoKipp from "../../images/kipp-logo.png";
import LogotipoOmint from "../../images/omint-logo.png";
import Loader from "../../components/Loader/Loader";
import { retornarCookie } from "../../services/cookieservice";
import { cnpjFormat } from "../../services/cnpjService";
import { encode as base64_encode } from "base-64";
import { PDFDocument } from 'pdf-lib';

const { REACT_APP_API, REACT_APP_URL_INSTANCE, } =
    process.env;

export default class ImpressaoPropostaPage extends React.Component {
    state = {
        InformacoesProposta: {},
        FuncionariosAtivosMedicina: undefined,
        FuncionariosAtivosOdonto: undefined,
        FuncionariosInativosMedicina: undefined,
        FuncionariosInativosOdonto: undefined,
        ExemploReembolsoMedicina: undefined,
        ExemploReembolsoOdonto: undefined,
        ReembolsoCoeficienteMedicina: undefined,
        ReembolsoCoeficienteOdonto: undefined,
        RedeCredenciada: undefined,
        Coparticipacoes: undefined,
        Observacoes: undefined,
        DecisaoProposta: undefined,
        Rodape: undefined,
        exibeCarregamento: false,
        exibeBaixandoArquivo: false,
        exibeFloatingMenu: false,
        exibeBotaoHome: false,
        Patologias: undefined,
        mostrarColunasCoparticipacoes: true
    };

    RecusarOportunidade = () => {
        const urlParams = new URLSearchParams(window.location.search);

        const PropostaId = urlParams.get("PropostaId");

        axios
            .put(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta?IdProposta=${PropostaId}&Decisao=${false}`,
                {}
            )
            .then((res) => {
                this.verificaPropostaDecisao(PropostaId);
            });
    };

    AceitarOportunidade = () => {
        const urlParams = new URLSearchParams(window.location.search);

        const PropostaId = urlParams.get("PropostaId");
        axios
            .put(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta?IdProposta=${PropostaId}&Decisao=${true}`,
                {}
            )
            .then((res) => {
                this.verificaPropostaDecisao(PropostaId);
            });
    };

    exportPdf = async () => {
        if (window.confirm("Deseja descarregar a proposta em PDF?")) {

            window.scrollTo(0, document.body.scrollHeight);

            this.setState({ exibeBaixandoArquivo: true });

            this.setState({ mostrarColunasCoparticipacoes: false });

            const showHiddenElements = document.querySelectorAll('.ShowHiddenToDownload');

            showHiddenElements.forEach(element => {
                element.style.display = 'block';
            });

            const cropDivs = document.querySelectorAll('.crop');
            const images = [];

            const printPageSize = {
                width: 1450,
                height: 1650,
            };

            const zoomFactor = 1.0;

            const addLogotipo = (div, index) => {
                const logotipoDiv = document.createElement('div');
                logotipoDiv.id = 'logotipo';

                const Marca = this.state.InformacoesProposta.Marca;

                const logotipoSrc = Marca === "3" ? LogotipoKipp : LogotipoOmint;

                logotipoDiv.innerHTML = `
          <img src="${logotipoSrc}" alt="Logo" id="logotipo" class="logotipo${Marca === "3" ? 'Kipp' : 'Omint'}Paginas" />
        `;

                div.insertBefore(logotipoDiv, div.firstChild);
            };

            const addAnsMark = (div) => {
                const ansMark = document.createElement('span');
                ansMark.id = 'ANSMARK';
                ansMark.className = 'ANSMARK';
                ansMark.textContent = 'ANS - n.º 35966-1';
                div.insertBefore(ansMark, div.firstChild);
            };

            const addPageHeaderTitle = (div, title) => {
                const pageHeaderTitle = document.createElement('div');
                pageHeaderTitle.className = 'pageHeaderTitle';
                pageHeaderTitle.textContent = title;
                div.insertBefore(pageHeaderTitle, div.firstChild);
            };

            const generateImage = async (div, index) => {
                div.style.margin = '0';
                div.style.padding = '0';

                const contentWidth = printPageSize.width * zoomFactor;
                const contentHeight = printPageSize.height * zoomFactor;

                div.style.width = (contentWidth - 200) + 'px';
                div.style.height = contentHeight + 'px';

                if (index !== 0) {
                    addLogotipo(div, index);
                    addAnsMark(div);
                    const title = div.getAttribute("data-pdf-header");
                    addPageHeaderTitle(div, title);
                }

                const canvas = await html2canvas(div, {
                    scrollX: 0,
                    scrollY: 0,
                    windowWidth: contentWidth,
                    windowHeight: contentHeight,
                    useCORS: true,
                    scale: zoomFactor,
                });

                const imgData = canvas.toDataURL('image/png');

                const divId = div.id;
                const ordemGeracao = (index + 1);

                const filename = `Proposta_${new URLSearchParams(window.location.search).get("PropostaId")}_${divId}.png`;

                images.push({ filename, data: imgData, ordemGeracao });

                if (images.length === cropDivs.length) {
                    this.sendImagesToAPI(images);

                    showHiddenElements.forEach(element => {
                        element.style.display = 'none';
                    });
                }
            };

            for (let index = 0; index < cropDivs.length; index++) {
                await generateImage(cropDivs[index], index);
            }
        }
    };

    sendImagesToAPI = async (images) => {
        const apiUrl = `${REACT_APP_API}/PDF/Criar`;
        const requestData = { imagens: images };

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
            });
            const data = await response.json();

            if (data.pdfBase64) {
                // Convert the generated PDF (in Base64) to a Blob
                const byteCharacters = atob(data.pdfBase64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const generatedPdfBlob = new Blob([byteArray], { type: 'application/pdf' });

                const base64String = await this.getBase64MPSOmint();
                const additionalPdfByteCharacters = atob(base64String.trim());
                const additionalPdfByteNumbers = new Array(additionalPdfByteCharacters.length);
                for (let i = 0; i < additionalPdfByteCharacters.length; i++) {
                    additionalPdfByteNumbers[i] = additionalPdfByteCharacters.charCodeAt(i);
                }
                const additionalPdfByteArray = new Uint8Array(additionalPdfByteNumbers);
                const additionalPdfBlob = new Blob([additionalPdfByteArray], { type: 'application/pdf' });

                // Merge PDFs
                const finalPdfBlob = await this.mergePdfs(generatedPdfBlob, additionalPdfBlob);

                // Create download link for the final PDF
                const url = window.URL.createObjectURL(finalPdfBlob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = `Proposta_${new URLSearchParams(window.location.search).get("PropostaId")}_${new Date().toLocaleDateString().replace(/\//g, "-")}.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                window.location.reload();
            }
        } catch (error) {
            console.error('Erro ao enviar imagens para a API:', error);
        }
    };

    getBase64MPSOmint = async () => {
        try {
            const response = await axios.get(`${REACT_APP_API}/MPSOmint/GetBase64MPSOmint`);
            const base64 = response.data.pdfBase64;

            console.log('Base64:', base64);
            return base64; // Ou processe o base64 como desejar
        } catch (error) {
            console.error('Erro ao buscar o Base64:', error);
            throw error;
        }
    };

    mergePdfs = async (pdf1Blob, pdf2Blob) => {
        const pdf1Bytes = await pdf1Blob.arrayBuffer();
        const pdf2Bytes = await pdf2Blob.arrayBuffer();

        const pdfDoc = await PDFDocument.load(pdf1Bytes);
        const pdfToMerge = await PDFDocument.load(pdf2Bytes);

        const copiedPages = await pdfDoc.copyPages(pdfToMerge, pdfToMerge.getPageIndices());
        copiedPages.forEach((page) => pdfDoc.addPage(page));

        const mergedPdfBytes = await pdfDoc.save();
        return new Blob([mergedPdfBytes], { type: 'application/pdf' });
    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    sendEmail = () => {
        this.FormatEmailBody();
        return false;
    };

    FormatEmailBody = () => {
        var mailtourl =
            "mailto:?subject=Omint%20Saúde&body=Temos novidades! %0D%0A %0D%0AJá emitimos a sua proposta para contratação do plano Omint Saúde. %0D%0A %0D%0AAgora, precisamos que você siga alguns passos: %0D%0A %0D%0AClique no link abaixo para avaliar a proposta emitida.%0D%0A %0D%0A" +
            encodeURIComponent(window.location.href) +
            " %0D%0A %0D%0ACaso seja necessária alguma correção ou você queira uma nova proposta, entre em contato com o seu corretor. %0D%0APronto! Feito isso, aguarde as orientações de seu corretor para que você siga com a contratação. %0D%0A %0D%0AEm caso de dúvidas, entre em contato com seu corretor Omint Saúde.";
        window.location.href = mailtourl;
        return false;
    };

    bloquearContextMenu = () => {
        if (document.addEventListener) {
            document.addEventListener("contextmenu", function (e) {
                e.preventDefault();
                return false;
            });
        } else { //Versões antigas do IE
            document.attachEvent("oncontextmenu", function (e) {
                e = e || window.event;
                e.returnValue = false;
                return false;
            });
        }

    }

    componentDidMount() {

        window.scrollTo(0, 0);

        this.bloquearContextMenu();

        document.addEventListener("keydown", function (event) {
            if (event.ctrlKey && (event.key === "p" || event.key === "P")) {
                event.preventDefault();
                alert("Para baixar a proposta clique no botão de impressão no canto superior direito da página.");
            }
        });

        document.onkeydown = function (e) {
            if (e.keyCode === 123) {
                alert('O uso da tecla F12 está desabilitado.');
                e.preventDefault();
                return false;
            }

            if (e.ctrlKey && e.shiftKey && (e.key === 'C' || e.key === 'c')) {
                alert('O uso de Ctrl + Shift + C está desabilitado.');
                e.preventDefault();
                return false;
            }
        };

        if (retornarCookie("Auth") !== null && retornarCookie("Auth") !== undefined && retornarCookie("Auth") !== '') {
            this.setState({ exibeBotaoHome: true });
        }

        this.setState({ exibeCarregamento: true });

        const urlParams = new URLSearchParams(window.location.search);

        const PropostaId = urlParams.get("PropostaId");

        axios
            .get(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta?IdProposta=${PropostaId}`
            )
            .then((result) => {
                this.setState({
                    InformacoesProposta: result.data,
                });
            });

        axios
            .get(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta/FuncionariosAtivosMedicina?IdProposta=${PropostaId}`
            )
            .then((result) => {
                if (result.data != null)
                    result.data.map(
                        (e) => (e.PlanosValores = this.gridProposta(e.PlanosValores))
                    );

                this.setState({
                    FuncionariosAtivosMedicina: result.data,
                });
            });

        axios
            .get(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta/FuncionariosAtivosOdonto?IdProposta=${PropostaId}`
            )
            .then((result) => {
                if (result.data != null)
                    result.data.map(
                        (e) => (e.PlanosValores = this.gridProposta(e.PlanosValores))
                    );

                this.setState({
                    FuncionariosAtivosOdonto: result.data,
                });
            });

        axios
            .get(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta/FuncionariosInativosMedicina?IdProposta=${PropostaId}`
            )
            .then((result) => {
                if (result.data != null)
                    result.data.map(
                        (e) => (e.PlanosValores = this.gridProposta(e.PlanosValores))
                    );

                this.setState({
                    FuncionariosInativosMedicina: result.data,
                });
            });

        axios
            .get(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta/FuncionariosInativosOdonto?IdProposta=${PropostaId}`
            )
            .then((result) => {
                if (result.data != null)
                    result.data.map(
                        (e) => (e.PlanosValores = this.gridProposta(e.PlanosValores))
                    );

                this.setState({
                    FuncionariosInativosOdonto: result.data,
                });
            });

        axios
            .get(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta/ExemploReembolsoMedicina?IdProposta=${PropostaId}`
            )
            .then((result) => {
                this.setState({
                    ExemploReembolsoMedicina: result.data,
                });
            });

        axios
            .get(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta/ExemploReembolsoOdonto?IdProposta=${PropostaId}`
            )
            .then((result) => {
                this.setState({
                    ExemploReembolsoOdonto: result.data,
                });
            });

        axios
            .get(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta/ReembolsoCoeficienteMedicina?IdProposta=${PropostaId}`
            )
            .then((result) => {

                // recupera todos os eventos, e mantem a ordem, criar uma lista com evento e ordem
                const eventosComOrdem = result.data.Eventos.map((evento, index) => ({ evento, index }));

                const reembolsosCoeficientesOrdenados = result.data.ReembolsosCoeficientes.map((reembolso) => {
                    // Garantir que todos os eventos estejam presentes para cada plano
                    const valoresCompletos = eventosComOrdem.map((eventoInfo) => {
                        // Procurar se o evento existe nos valores do plano atual
                        const valorExistente = reembolso.Valores.find((valor) => valor.Evento === eventoInfo.evento);

                        if (valorExistente) {
                            // Se existe, usar o valor existente com o índice correto
                            return { ...valorExistente, index: eventoInfo.index };
                        } else {
                            // Se não existe, criar um valor padrão com "-"
                            return {
                                Plano: reembolso.Plano,
                                Evento: eventoInfo.evento,
                                Valor: "-",
                                Linha: 0,
                                index: eventoInfo.index
                            };
                        }
                    });

                    // Ordenar pelos índices dos eventos para manter a ordem original
                    valoresCompletos.sort((a, b) => a.index - b.index);

                    return { ...reembolso, Valores: valoresCompletos };
                });

                // criar novo json na mesma estrutura do retorno original, mas com os valores ordenados e completos
                const retornoFormatado = {
                    Eventos: result.data.Eventos,
                    ReembolsosCoeficientes: reembolsosCoeficientesOrdenados
                };

                this.setState({
                    ReembolsoCoeficienteMedicina: retornoFormatado,
                });
            });

        axios
            .get(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta/ReembolsoCoeficienteOdontologico?IdProposta=${PropostaId}`
            )
            .then((result) => {

                // recupera todos os eventos, e mantem a ordem, criar uma lista com evento e ordem
                const eventosComOrdem = result.data.Eventos.map((evento, index) => ({ evento, index }));

                const reembolsosCoeficientesOrdenados = result.data.ReembolsosCoeficientes.map((reembolso) => {
                    // Garantir que todos os eventos estejam presentes para cada plano
                    const valoresCompletos = eventosComOrdem.map((eventoInfo) => {
                        // Procurar se o evento existe nos valores do plano atual
                        const valorExistente = reembolso.Valores.find((valor) => valor.Evento === eventoInfo.evento);

                        if (valorExistente) {
                            // Se existe, usar o valor existente com o índice correto
                            return { ...valorExistente, index: eventoInfo.index };
                        } else {
                            // Se não existe, criar um valor padrão com "-"
                            return {
                                Plano: reembolso.Plano,
                                Evento: eventoInfo.evento,
                                Valor: "-",
                                Linha: 0,
                                index: eventoInfo.index
                            };
                        }
                    });

                    // Ordenar pelos índices dos eventos para manter a ordem original
                    valoresCompletos.sort((a, b) => a.index - b.index);

                    return { ...reembolso, Valores: valoresCompletos };
                });

                // criar novo json na mesma estrutura do retorno original, mas com os valores ordenados e completos
                const retornoFormatado = {
                    Eventos: result.data.Eventos,
                    ReembolsosCoeficientes: reembolsosCoeficientesOrdenados
                };

                this.setState({
                    ReembolsoCoeficienteOdonto: retornoFormatado,
                });
            });

        axios
            .get(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta/RedeCredenciada?IdProposta=${PropostaId}`
            )
            .then((result) => {

                // Temos que garantir que todo prestador informado em RedesCredenciadas.Planos.Valores.Prestadores esteja presente em RedesCredenciadas.Prestadores
                // e todos na mesma ordem alfabética
                // recupera todos os prestadores dos Plano.Valores.Prestadores
                // se não estiverem em Prestadores, adiciona
                // ordena Prestadores
                // para cada prestador, passa por cada Plano.Valores e verifica se o prestador está presente
                // se não estiver, adiciona um objeto com os valores padrão e habilitado = "Não", Grupo = "Não informado", Linha = 0, Ordem = 0
                // todas as listas em Plano.Valores devem ter o mesmo tamanho e todas devem estar ordenadas pelo Prestador
                // assim não teremos problemas de exibição, pois a lista de prestadores sempre irá bater com a lista de valores

                // clonar result.data para ter o valor original
                const resultClonado = JSON.parse(JSON.stringify(result.data));

                // recupera todos os prestadores dos Plano.Valores.Prestadores, do plano com maior quantidade de .Valores
                // mas como json { prestador, index }
                const maiorPlano = resultClonado.RedesCredenciadas.reduce((prev, current) => (prev.Valores.length > current.Valores.length) ? prev : current);
                const prestadoresDoMaiorPlanoNaOrdem = maiorPlano.Valores.map((v, index) => ({ prestador: v.Prestadores, index }));

                // algum plano pode ter a mesma quantidade de valores do maior plano mas não ter os mesmos prestadores
                // recuperar os prestadores de todos os planos, com sua devida ordem. Não duplicar os prestadores
                const todosPlanosComOrdem = [];
                resultClonado.RedesCredenciadas.forEach((plano) => {
                    plano.Valores.forEach((valor, index) => {
                        if (!todosPlanosComOrdem.some(p => p.prestador === valor.Prestadores)) {
                            todosPlanosComOrdem.push({ prestador: valor.Prestadores, index });
                        }
                    });
                });
                // ver quais planos com ordem não estão em prestadoresDoMaiorPlanoNaOrdem
                const prestadoresFaltantes = todosPlanosComOrdem.filter(p => !prestadoresDoMaiorPlanoNaOrdem.some(p2 => p2.prestador === p.prestador));

                // adicionar os prestadores faltantes em prestadoresDoMaiorPlanoNaOrdem no final
                prestadoresFaltantes.forEach(p => prestadoresDoMaiorPlanoNaOrdem.push(p));

                // ordenar prestadoresDoMaiorPlanoNaOrdem pela ordem original
                prestadoresDoMaiorPlanoNaOrdem.sort((a, b) => a.index - b.index);


                const duplicadosCriados = []; // {plano, prestador, grupo, nomeDuplicado }

                result.data.RedesCredenciadas.forEach((plano) => {
                    plano.Valores.forEach((valor) => {
                        // verifica se o prestador aparece mais de uma vez nesse plano, pois, o grupo pode ser diferente
                        const prestadorDuplicado = plano.Valores.filter((v) => v.Prestadores === valor.Prestadores);
                        if (prestadorDuplicado.length > 1) {
                            // sendo duplicado, para cada um desses, inserir na lista de result.data.Prestadores
                            // se o nome existir, concatena o nome com " - 2" 3 etc
                            // se não existir, adiciona
                            prestadorDuplicado.forEach((duplicado, index) => {
                                if (!result.data.Prestadores.includes(valor.Prestadores)) {
                                    result.data.Prestadores.push(valor.Prestadores);
                                } else {
                                    // se já existe e o index for o primeiro, não faz nada
                                    // se não, concatena o nome com o index + 2
                                    if (index > 0) {
                                        const nomeDuplicado = `${duplicado.Prestadores} ## ${index + 1}`;
                                        if (!result.data.Prestadores.includes(nomeDuplicado)) {
                                            result.data.Prestadores.push(nomeDuplicado);
                                            valor.jaPossuiDuplicado = true;
                                            duplicadosCriados.push({ plano: plano.Plano, prestador: duplicado.Prestadores, grupo: duplicado.Grupo, nomeDuplicado });
                                        }
                                    }
                                }
                            });
                        } else {
                            if (!result.data.Prestadores.includes(valor.Prestadores)) {
                                result.data.Prestadores.push(valor.Prestadores);
                            }
                        }
                    });
                });

                result.data.Prestadores.sort();

                // para cada prestador, passa por cada Plano.Valores e verifica se o prestador está presente
                // se não estiver, adiciona um objeto com os valores padrão e habilitado = "Não", Grupo = "Não informado", Linha = 0, Ordem = 0
                result.data.Prestadores.forEach((prestador) => {
                    result.data.RedesCredenciadas.forEach((plano) => {
                        if (!plano.Valores.some((valor) => valor.Prestadores === prestador)
                            && !plano.Valores.some((valor) => valor.jaPossuiDuplicado)
                            && plano.Valores.length < result.data.Prestadores.length
                        ) {
                            plano.Valores.push({
                                Filial: "Não informado",
                                Grupo: "Não informado",
                                Habilitado: "Não",
                                Linha: 0,
                                Ordem: 0,
                                Plano: plano.Plano,
                                Prestadores: prestador
                            });
                        }
                    });
                });

                // sempre dar sort no plano pelo prestador para manter ambos os arrays na mesma ordem
                result.data.RedesCredenciadas.forEach((plano) => {
                    plano.Valores.sort((a, b) => a.Prestadores.localeCompare(b.Prestadores));
                });

                // para cada result.data.Prestadores, se tiver no prestador "##", substituir pelo nome original
                result.data.Prestadores.forEach((prestador, index) => {
                    if (prestador.includes("##")) {
                        const duplicado = duplicadosCriados.find((d) => d.nomeDuplicado === prestador);
                        if (duplicado) {
                            result.data.Prestadores[index] = duplicado.prestador;
                        }
                    }
                });

                // agora, temos que voltar a ordem dos prestadores para a ordem original
                const prestadoresOrdenados = [];
                prestadoresDoMaiorPlanoNaOrdem.forEach((p) => {
                    const prestador = result.data.Prestadores.find((prestador) => prestador === p.prestador);
                    if (prestador) {
                        prestadoresOrdenados.push(prestador);
                    }
                });

                result.data.Prestadores = prestadoresOrdenados;

                // ordenar também os valores de cada plano, pelo index em prestadoresDoMaiorPlanoNaOrdem
                result.data.RedesCredenciadas.forEach((plano) => {
                    const valoresOrdenados = [];
                    prestadoresDoMaiorPlanoNaOrdem.forEach((p) => {
                        const valor = plano.Valores.find((v) => v.Prestadores === p.prestador);
                        if (valor) {
                            valoresOrdenados.push(valor);
                        } else {
                            throw new Error(`Prestador ${p.prestador} não encontrado no plano ${plano.Plano}`);
                        }
                    });
                    plano.Valores = valoresOrdenados;
                });

                this.setState({
                    RedeCredenciada: result.data,
                });
            });

        axios
            .get(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta/RedeCobertura?IdProposta=${PropostaId}`
            )
            .then((result) => {
                this.setState({
                    RedeCobertura: result.data,
                });
            });

        axios
            .get(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta/Observacoes?IdProposta=${PropostaId}`
            )
            .then((result) => {
                this.setState({
                    Observacoes: result.data,
                });
            });

        axios
            .get(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta/Coparticipacoes?IdProposta=${PropostaId}`
            )
            .then((result) => {
                this.setState({
                    Coparticipacoes: result.data,
                });
            });

        axios
            .get(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta/Patologias?IdProposta=${PropostaId}`
            )
            .then((result) => {
                this.setState({
                    Patologias: result.data,
                });
            });

        axios
            .get(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta/Rodape?IdProposta=${PropostaId}`
            )
            .then((result) => {
                this.setState({
                    Rodape: result.data,
                });
                this.setState({ exibeCarregamento: false });
            });

        this.verificaPropostaDecisao(PropostaId);
    }

    gridProposta(planosValores) {
        var novoArray = [];
        var corte = 7;

        for (var j = 0; j < planosValores.length; j = j + corte) {
            novoArray.push(planosValores.slice(j, j + corte));
        }

        return (planosValores = novoArray);
    }

    voltarHomePage = () => {
        const redirectTo = base64_encode("HomePage");

        document.location.href = `${REACT_APP_URL_INSTANCE}${redirectTo}&Auth=${base64_encode(
            retornarCookie("Auth")
        )}`;
    }

    verificaPropostaDecisao(propostaId) {
        axios
            .get(
                `${REACT_APP_API}CotacaoPME/ImpressaoProposta/VerificarPropostaDecisao?IdProposta=${propostaId}`
            )
            .then((res) => {
                this.setState({ DecisaoProposta: res.data.Validador });
            });
    }

    handleMenuItemClick = (targetDiv) => {
        const targetElement = document.getElementById(targetDiv);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    render() {
        const NomeEmpresa = (marca) => {
            return <span>{marca === "3" ? "Kipp Saúde" : "Omint Saúde"}</span>;
        };

        const cortarArray = (array, size) => {

            const result = [];
            for (let i = 0; i < array.length; i += size) {
                result.push(array.slice(i, i + size));
            }
            return result;
        }

        const normalizarLinhasPlano = (faixas, vidas, planos) => {
            const faixasArr = Array.isArray(faixas) ? [...faixas] : [];
            const vidasArr = Array.isArray(vidas) ? [...vidas] : [];
            const planosArr = Array.isArray(planos)
                ? planos.map((p) => ({
                    ...p,
                    Valores: Array.isArray(p.Valores) ? [...p.Valores] : [],
                }))
                : [];

            const targetLen = faixasArr.length;

            if (vidasArr.length > targetLen) vidasArr.length = targetLen;
            while (vidasArr.length < targetLen) vidasArr.push(0);
            planosArr.forEach((p) => {
                if (p.Valores.length > targetLen) p.Valores.length = targetLen;
                while (p.Valores.length < targetLen) p.Valores.push({ Valor: 0 });
            });

            return { faixas: faixasArr, vidas: vidasArr, planos: planosArr };
        };

        const preencheLinhas = (array, size, mostrarColunasCoparticipacoes) => {
            const result = [];
            for (let i = 0; i < array.length; i += size) {
                const chunk = array.slice(i, i + size);
                // Preencher com linhas vazias se o último corte não ocupar 18 posições
                const diff = size - chunk.length;

                if (mostrarColunasCoparticipacoes) {
                    for (let j = 0; j < diff; j++) {
                        chunk.push({ Plano: '', Acesso: '', Evento: '', Prestadores: '', Valor_Copart: '', Valor_Limite: '' });
                    }
                }

                result.push(chunk);
            }
            return result;
        };


        const formatarReal = (valor) => {
            if (valor !== null && valor !== undefined) {
                if (Number(valor) === 0) {
                    valor = "-";

                    return valor;
                } else {
                    valor = valor.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                    });

                    return valor;
                }
            }

            return valor;
        };

        const formatarRealcom4casas = (valor) => {
            const numericValue = parseFloat(valor);
            if (isNaN(numericValue)) {
                return "-";
            }

            const formattedValue = `${numericValue.toFixed(4).replace(".", ",")}`;
            return formattedValue;
        };

        const LogotipoEmpresa = (Marca) => {
            if (Marca === "3") {
                return (
                    <img src={LogotipoKipp} alt="LogoKipp" id="logotipo" className="logotipoKipp" />
                );
            } else {
                return (
                    <img src={LogotipoOmint} alt="LogoOmint" id="logotipo" className="logotipoOmint" />
                );
            }
        };

        return (
            <div className="fade-in">

                {this.state.exibeBaixandoArquivo && <div className="BaixandoArquivoCanva fade-in-quickie">
                    <div className="centralizar">
                        <span class="loaderGerandoPDfProposta"></span>
                    </div>
                    <div className="centralizar BaixandoArquivoTexto">
                        Por favor, aguarde um momento enquanto preparamos o seu documento para download.<br /><br />

                    </div>
                </div>}

                {!this.state.exibeFloatingMenu && <div className="FloatingMenuOpenButton" onClick={() => this.setState({ exibeFloatingMenu: true })}><MaterialIcon icon="more_horiz" /></div>}

                {this.state.exibeFloatingMenu && <div className="FloatingMenu">
                    <div className="closeButtonFloatingMenu" onClick={() => this.setState({ exibeFloatingMenu: false })}><MaterialIcon icon="close" /></div>
                    <ul>
                        {
                            <li className="FloatingMenuItem"
                                onClick={() => this.handleMenuItemClick('Cabecalho')}>Cabeçalho</li>}


                        {this.state.FuncionariosAtivosMedicina && this.state.FuncionariosAtivosMedicina.length > 0 &&
                            <li className="FloatingMenuItem"
                                onClick={() => this.handleMenuItemClick('FuncionariosAtivosMedicina')}>Funcionarios Ativos - Medicina</li>}

                        {this.state.FuncionariosAtivosOdonto && this.state.FuncionariosAtivosOdonto.length > 0 &&
                            <li className="FloatingMenuItem"
                                onClick={() => this.handleMenuItemClick('FuncionariosAtivosOdonto')}>Funcionarios Ativos - Odontologia</li>}

                        {this.state.FuncionariosInativosMedicina && this.state.FuncionariosInativosMedicina.length > 0 &&
                            <li className="FloatingMenuItem"
                                onClick={() => this.handleMenuItemClick('FuncionariosInativosMedicina')}>Funcionarios Inativos - Medicina</li>}

                        {this.state.FuncionariosInativosOdonto && this.state.FuncionariosInativosOdonto.length > 0 &&
                            <li className="FloatingMenuItem"
                                onClick={() => this.handleMenuItemClick('FuncionariosInativosOdonto')}>Funcionarios Inativos - Odontologia</li>}

                        {this.state.ReembolsoCoeficienteMedicina &&
                            <li className="FloatingMenuItem"
                                onClick={() => this.handleMenuItemClick('ExemploReembolsoMedicina')}>Exemplos Reembolso - Medicina</li>}

                        {this.state.ReembolsoCoeficienteOdonto &&
                            <li className="FloatingMenuItem"
                                onClick={() => this.handleMenuItemClick('ExemploReembolsoOdonto')}>Exemplos Reembolso - Odontologia</li>}

                        {this.state.RedeCredenciada &&
                            <li className="FloatingMenuItem"
                                onClick={() => this.handleMenuItemClick('ExemplosRedeCredenciada')}>Rede Credenciada</li>}

                        {this.state.RedeCobertura &&
                            <li className="FloatingMenuItem"
                                onClick={() => this.handleMenuItemClick('CoberturasOdontologicas')}>Rede Cobertura</li>}

                        {this.state.Coparticipacoes &&
                            <li className="FloatingMenuItem"
                                onClick={() => this.handleMenuItemClick('Coparticipacoes')}>Coparticipações</li>}

                        {this.state.Patologias &&
                            <li className="FloatingMenuItem"
                                onClick={() => this.handleMenuItemClick('Patologias')}>Patologias</li>}

                        {this.state.Observacoes &&
                            <li className="FloatingMenuItem"
                                onClick={() => this.handleMenuItemClick('Observacoes')}>Observações</li>}
                    </ul>
                </div>}

                {this.state.exibeCarregamento && <Loader />}



                <div className="NavigationSuperior">
                    <div className="row container">
                        <div className="col s8 m8 l8">
                            <b>
                                <h5>Proposta : {this.state.InformacoesProposta.PropostaId}</h5>
                            </b>
                            Por favor, revise atentamente os detalhes do(s) seu(s) novo(s) plano(s) antes de aceitar a proposta.
                        </div>
                        <div className="col s4 m4 l4 right-align">
                            <br />
                            <br />
                            <div id="email" href="#">
                                <MaterialIcon
                                    icon="email"
                                    onClick={() => {
                                        this.sendEmail();
                                    }}
                                />
                                <MaterialIcon
                                    icon="file_download"
                                    onClick={() => {
                                        this.exportPdf();
                                    }}
                                />
                                {this.state.exibeBotaoHome && <MaterialIcon
                                    icon="home"
                                    onClick={() => {
                                        this.voltarHomePage();
                                    }}
                                />}
                            </div>
                        </div>
                    </div>
                </div>

                <div id="capture">

                    <div className="crop" id="Cabecalho">
                        <div className="row container">
                            <div className="col s8 m8 l8">
                                {LogotipoEmpresa(this.state.InformacoesProposta.Marca)}
                            </div>
                            <div className="col s4 m4 l4 right-align">
                                <br />
                                Proposta número :{" "}
                                <b>{this.state.InformacoesProposta.PropostaId}</b>
                            </div>
                        </div>

                        <div className="row container">
                            <div className="col s12 m12 l12">
                                <b>
                                    <h5>
                                        Proposta para contratação | Planos{" "}
                                        {NomeEmpresa(this.state.InformacoesProposta.Marca)}
                                    </h5>
                                </b>
                            </div>
                        </div>

                        <div className="row container box">
                            <div className="col s6 m6 l6">
                                <b>Razão Social</b>
                                <br />
                                {this.state.InformacoesProposta.RazaoSocial}
                            </div>
                            <div className="col s6 m3 l3">
                                <b>CNPJ</b>
                                <br />
                                {this.state.InformacoesProposta.CNPJ}
                            </div>
                            <div className="col s6 m3 l3">
                                <b>Contato</b>
                                <br />
                                {this.state.InformacoesProposta.ContatoNome ?? "--"}
                            </div>

                            <div className="col s12 m12 l12 divider"> </div>

                            <div className="col s6 m3 l3">
                                <b>Números de vidas da proposta</b>
                                <br />
                                {this.state.InformacoesProposta.QtdeVidas}
                            </div>
                            <div className="col s6 m3 l3">
                                <b>Modo de contratação</b>
                                <br />
                                {this.state.InformacoesProposta.ModoContratacao ?? "--"}
                            </div>
                            <div className="col s6 m3 l3">
                                <b>Data da proposta</b>
                                <br />
                                {this.state.InformacoesProposta.DateTime}
                            </div>
                            <div className="col s6 m3 l3">
                                <b>Validade da proposta</b>
                                <br />
                                {this.state.InformacoesProposta.DataValidade ?? "--"}
                            </div>

                            <div className="col s12 m12 l12 divider"> </div>

                            <div className="col s6 m6 l6">
                                <b>Agente(s)</b>
                                <br />
                                {this.state.InformacoesProposta.AgenteVenda}
                            </div>
                            <div className="col s6 m6 l6">
                                <b>Assessoria</b>
                                <br />
                                --
                            </div>
                        </div>

                        <div className="col s12 m12 l12 left-align mensagemAbordagemProposta ShowHiddenToDownload" id="mensagemAbordagemProposta">
                            <p><b>Prezados Senhores(as),</b>
                                <br /><br />A Omint agradece a oportunidade de apresentar esta proposta e participar dessa importante decisão:
                                <br /><br />a escolha do plano que cuidará da saúde dos funcionários de sua empresa e suas famílias.
                                <br /><br />Além de produtos que garantem ao cliente a certeza de poder contar com o melhor da medicina e da
                                <br /><br />odontologia, a Omint oferece condições comerciais e ferramentas de gestão customizadas, para
                                <br /><br />transformar os cuidados com a saúde em um investimento seguro.
                                <br /><br />A seguir, apresentamos as principais características e diferenciais de nossos produtos e a Proposta
                                <br /><br />Comercial, com simulações de preços para a composição de seu contrato.
                                <br /><br />Obrigado(a) pela confiança!
                                <br /><br /><b>Omint Serviços de Saúde S.A.</b></p>
                        </div>
                    </div>

                    {this.state.FuncionariosAtivosMedicina && this.state.FuncionariosAtivosMedicina.length > 0 && (

                        <div className="modalidadePlano primeiroPlano">
                            <div className="row container">
                                <div className="col s12 m12 l12">
                                    <h6>
                                        <b>Funcionários ativos: </b>Titulares e Dependentes -
                                        Medicina
                                    </h6>
                                </div>
                            </div>
                            {this.state.FuncionariosAtivosMedicina.map((e) => (
                                <>
                                    {e.PlanosValores.map((planosOriginal) => {
                                        const { faixas, vidas, planos } = normalizarLinhasPlano(e.Faixas, e.Vidas, planosOriginal);
                                        return (
                                            <div className="crop" id="FuncionariosAtivosMedicina" data-pdf-header="Funcionários ativos: Titulares e Dependentes - Medicina">
                                                <div className="row container planos">
                                                    <div className="ShowHiddenToDownload"><div className="PageHeaderSpace"></div></div>
                                                    <Table>
                                                        <thead>
                                                            <tr>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                <td className="Header2">{e.Elegibilidade}</td>
                                                                {planos.map((p) => (
                                                                    <td className="Header">
                                                                        <b>{p.Plano}</b>
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <Table>
                                                                        <thead>
                                                                            <tr>
                                                                                <td>
                                                                                    <b>Faixa Etária</b>
                                                                                </td>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {faixas.map((f) => (
                                                                                <tr>
                                                                                    <td>{f}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </Table>
                                                                </td>
                                                                <td>
                                                                    <Table>
                                                                        <thead>
                                                                            <tr>
                                                                                <td>
                                                                                    <b>Vidas</b>
                                                                                </td>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {vidas.map((v) => (
                                                                                <tr>
                                                                                    <td>{v ?? 0}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </Table>
                                                                </td>
                                                                {planos &&
                                                                    planos.map((p) => (
                                                                        <td>
                                                                            <Table>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <td>
                                                                                            <b>Valor</b>
                                                                                        </td>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {p.Valores &&
                                                                                        p.Valores.map((v) => (
                                                                                            <tr>
                                                                                                <td className="Valor">
                                                                                                    {formatarReal(v.Valor)}
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))}
                                                                                </tbody>
                                                                            </Table>
                                                                        </td>
                                                                    ))}
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <b>Total:</b>
                                                                </td>
                                                                <td>
                                                                    {" "}
                                                                    <b>
                                                                        <span>
                                                                            {" "}
                                                                            {vidas.reduce((acc, c) => acc + (Number(c) || 0), 0)}
                                                                        </span>
                                                                    </b>
                                                                </td>
                                                                {planos &&
                                                                    planos.map((p) => (
                                                                        <td>
                                                                            <b>{formatarReal(p.Total)}</b>
                                                                        </td>
                                                                    ))}
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </>
                            ))}
                        </div>

                    )}

                    {this.state.FuncionariosAtivosOdonto && this.state.FuncionariosAtivosOdonto.length > 0 && (

                        <div className="modalidadePlano">
                            <div className="row container">
                                <div className="col s12 m12 l12">
                                    <h6>
                                        <b>Funcionários ativos: </b>Titulares e Dependentes -
                                        Odontologia
                                    </h6>
                                </div>
                            </div>
                            {this.state.FuncionariosAtivosOdonto.map((e) => (
                                <div>
                                    {e.PlanosValores.map((planosOriginal) => {
                                        const { faixas, vidas, planos } = normalizarLinhasPlano(e.Faixas, e.Vidas, planosOriginal);
                                        return (
                                            <div className="crop" id="FuncionariosAtivosOdonto" data-pdf-header="Funcionários ativos: Titulares e Dependentes - Odontologia">
                                                <div className="row container planos">
                                                    <div className="ShowHiddenToDownload"><div className="PageHeaderSpace"></div></div>
                                                    <Table>
                                                        <thead>
                                                            <tr>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                <td className="Header2">{e.Elegibilidade}</td>
                                                                {planos.map((p) => (
                                                                    <td className="Header">
                                                                        <b>{p.Plano}</b>
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <Table>
                                                                        <thead>
                                                                            <tr>
                                                                                <td>
                                                                                    <b>Faixa Etária</b>
                                                                                </td>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {faixas.map((f) => (
                                                                                <tr>
                                                                                    <td>{f}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </Table>
                                                                </td>
                                                                <td>
                                                                    <Table>
                                                                        <thead>
                                                                            <tr>
                                                                                <td>
                                                                                    <b>Vidas</b>
                                                                                </td>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {vidas.map((v) => (
                                                                                <tr>
                                                                                    <td>{v ?? 0}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </Table>
                                                                </td>
                                                                {planos &&
                                                                    planos.map((p) => (
                                                                        <td>
                                                                            <Table>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <td>
                                                                                            <b>Valor</b>
                                                                                        </td>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {p.Valores.map((v) => (
                                                                                        <tr>
                                                                                            <td className="Valor">
                                                                                                {formatarReal(v.Valor)}
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </Table>
                                                                        </td>
                                                                    ))}
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <b>Total:</b>
                                                                </td>
                                                                <td>
                                                                    {" "}
                                                                    <b>
                                                                        <span>
                                                                            {" "}
                                                                            {vidas.reduce((acc, c) => acc + (Number(c) || 0), 0)}
                                                                        </span>
                                                                    </b>
                                                                </td>
                                                                {planos &&
                                                                    planos.map((p) => (
                                                                        <td>
                                                                            <b>{formatarReal(p.Total)}</b>
                                                                        </td>
                                                                    ))}
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ))}
                        </div>
                    )}

                    {this.state.FuncionariosInativosMedicina && this.state.FuncionariosInativosMedicina.length > 0 && (

                        <div className="modalidadePlano">
                            <div className="row container">
                                <div className="col s12 m12 l12">
                                    <h6>
                                        <b>Funcionários Inativos: </b>Titulares e Dependentes -
                                        Medicina
                                    </h6>
                                </div>
                            </div>
                            {this.state.FuncionariosInativosMedicina.map((e) => (
                                <>
                                    {e.PlanosValores.map((planosOriginal) => {
                                        const { faixas, vidas, planos } = normalizarLinhasPlano(e.Faixas, e.Vidas, planosOriginal);
                                        return (
                                            <div className="crop" id="FuncionariosInativosMedicina" data-pdf-header="Funcionários Inativos: Titulares e Dependentes - Medicina">
                                                <div className="row container planos">
                                                    <div className="ShowHiddenToDownload"><div className="PageHeaderSpace"></div></div>
                                                    <Table>
                                                        <thead>
                                                            <tr>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                <td className="Header2">{e.Elegibilidade}</td>
                                                                {planos.map((p) => (
                                                                    <td className="Header">
                                                                        <b>{p.Plano}</b>
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <Table>
                                                                        <thead>
                                                                            <tr>
                                                                                <td>
                                                                                    <b>Faixa Etária</b>
                                                                                </td>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {faixas.map((f) => (
                                                                                <tr>
                                                                                    <td>{f}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </Table>
                                                                </td>
                                                                <td>
                                                                    <Table>
                                                                        <thead>
                                                                            <tr>
                                                                                <td>
                                                                                    <b>Vidas</b>
                                                                                </td>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {vidas.map((v) => (
                                                                                <tr>
                                                                                    <td>{v ?? 0}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </Table>
                                                                </td>
                                                                {planos &&
                                                                    planos.map((p) => (
                                                                        <td>
                                                                            <Table>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <td>
                                                                                            <b>Valor</b>
                                                                                        </td>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {p.Valores.map((v) => (
                                                                                        <tr>
                                                                                            <td className="Valor">
                                                                                                {formatarReal(v.Valor)}
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </Table>
                                                                        </td>
                                                                    ))}
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <b>Total:</b>
                                                                </td>
                                                                <td>
                                                                    {" "}
                                                                    <b>
                                                                        <span>
                                                                            {" "}
                                                                            {vidas.reduce((acc, c) => acc + (Number(c) || 0), 0)}
                                                                        </span>
                                                                    </b>
                                                                </td>
                                                                {planos &&
                                                                    planos.map((p) => (
                                                                        <td>
                                                                            <b>{formatarReal(p.Total)}</b>
                                                                        </td>
                                                                    ))}
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </>
                            ))}
                        </div>

                    )}

                    {this.state.FuncionariosInativosOdonto && this.state.FuncionariosInativosOdonto.length > 0 && (

                        <div className="modalidadePlano">
                            <div className="row container">
                                <div className="col s12 m12 l12">
                                    <h6>
                                        <b>Funcionários Inativos: </b>Titulares e Dependentes -
                                        Odontologia
                                    </h6>
                                </div>
                            </div>
                            {this.state.FuncionariosInativosOdonto.map((e) => (
                                <>
                                    {e.PlanosValores.map((planosOriginal) => {
                                        const { faixas, vidas, planos } = normalizarLinhasPlano(e.Faixas, e.Vidas, planosOriginal);
                                        return (
                                            <div className="crop" id="FuncionariosInativosOdonto" data-pdf-header="Funcionários Inativos: Titulares e Dependentes - Odontologia">
                                                <div className="row container planos">
                                                    <div className="ShowHiddenToDownload"><div className="PageHeaderSpace"></div></div>
                                                    <Table>
                                                        <thead>
                                                            <tr>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                <td className="Header2">{e.Elegibilidade}</td>
                                                                {planos.map((p) => (
                                                                    <td className="Header">
                                                                        <b>{p.Plano}</b>
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <Table>
                                                                        <thead>
                                                                            <tr>
                                                                                <td>
                                                                                    <b>Faixa Etária</b>
                                                                                </td>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {faixas.map((f) => (
                                                                                <tr>
                                                                                    <td>{f}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </Table>
                                                                </td>
                                                                <td>
                                                                    <Table>
                                                                        <thead>
                                                                            <tr>
                                                                                <td>
                                                                                    <b>Vidas</b>
                                                                                </td>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {vidas.map((v) => (
                                                                                <tr>
                                                                                    <td>{v ?? 0}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </Table>
                                                                </td>
                                                                {planos &&
                                                                    planos.map((p) => (
                                                                        <td>
                                                                            <Table>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <td>
                                                                                            <b>Valor</b>
                                                                                        </td>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {p.Valores.map((v) => (
                                                                                        <tr>
                                                                                            <td className="Valor">
                                                                                                {formatarReal(v.Valor)}
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </Table>
                                                                        </td>
                                                                    ))}
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <b>Total:</b>
                                                                </td>
                                                                <td>
                                                                    {" "}
                                                                    <b>
                                                                        <span>
                                                                            {" "}
                                                                            {vidas.reduce((acc, c) => acc + (Number(c) || 0), 0)}
                                                                        </span>
                                                                    </b>
                                                                </td>
                                                                {planos &&
                                                                    planos.map((p) => (
                                                                        <td>
                                                                            <b>{formatarReal(p.Total)}</b>
                                                                        </td>
                                                                    ))}
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </>
                            ))}
                        </div>
                    )}

                    {this.state.ExemploReembolsoMedicina && (
                        <>
                            <div className="row container">
                                <div className="col s12 m12 l12">
                                    <h6>
                                        <b>Exemplos de Reembolso: </b>
                                    </h6>
                                </div>
                            </div>

                            <div className="modalidadePlano">
                                <div className="row container planos">
                                    {cortarArray(
                                        this.state.ExemploReembolsoMedicina.ExemplosReembolso,
                                        7
                                    ).map((pular, index) => (
                                        <div>
                                            <div
                                                className="crop"
                                                id="ExemploReembolsoMedicina"
                                                data-pdf-header="Exemplos de reembolso - Medicina"
                                            >
                                                <div className="row container planos">
                                                    <div className="ShowHiddenToDownload"><div className="PageHeaderSpace"></div></div>
                                                    <Table key={index}>
                                                        <thead>
                                                            <tr>
                                                                <td className="headerWithoutBackground"></td>
                                                                {pular.map((e) => (
                                                                    <td className="Header" key={e.Plano}>
                                                                        <b>{e.Plano}</b>
                                                                    </td>
                                                                ))}
                                                                {Array.from({ length: 7 - pular.length }).map((_, i) => (
                                                                    <td key={`empty-${i}`}></td>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <Table>
                                                                        <tbody>
                                                                            {this.state.ExemploReembolsoMedicina.Procedimentos.map(
                                                                                (p) => (
                                                                                    <tr key={p}>
                                                                                        <td className="left-align space-left">{p}</td>
                                                                                    </tr>
                                                                                )
                                                                            )}
                                                                        </tbody>
                                                                    </Table>
                                                                </td>
                                                                {pular.map((e) => (
                                                                    <td key={e.Plano}>
                                                                        <Table>
                                                                            <tbody>
                                                                                {e.Valores.map((v) => (
                                                                                    <tr key={v.Valor}>
                                                                                        <td className="Valor">{formatarReal(v.Valor)}</td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </Table>
                                                                    </td>
                                                                ))}
                                                                {Array.from({ length: 7 - pular.length }).map((_, i) => (
                                                                    <td key={`empty-${i}`}></td>
                                                                ))}
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div></div>
                                    ))}
                                </div>
                            </div>
                        </>
                    )}

                    {this.state.ExemploReembolsoOdonto && (
                        <>
                            <div className="row container">
                                <div className="col s12 m12 l12">
                                    <h6>
                                        <b>Exemplos de Reembolso: </b>
                                    </h6>
                                </div>
                            </div>

                            <div className="modalidadePlano">
                                <div className="row container planos">
                                    {cortarArray(
                                        this.state.ExemploReembolsoOdonto.ExemplosReembolso,
                                        7
                                    ).map((pular, index) => (
                                        <div>
                                            <div
                                                className="crop"
                                                id="ExemploReembolsoOdonto"
                                                data-pdf-header="Exemplos de reembolso - Odontologia"
                                            >
                                                <div className="row container planos">
                                                    <div className="ShowHiddenToDownload"><div className="PageHeaderSpace"></div></div>
                                                    <Table key={index}>
                                                        <thead>
                                                            <tr>
                                                                <td className="headerWithoutBackground"></td>
                                                                {pular.map((e) => (
                                                                    <td className="Header" key={e.Plano}>
                                                                        <b>{e.Plano}</b>
                                                                    </td>
                                                                ))}
                                                                {Array.from({ length: 7 - pular.length }).map((_, i) => (
                                                                    <td key={`empty-${i}`}></td>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <Table>
                                                                        <tbody>
                                                                            {this.state.ExemploReembolsoOdonto.Procedimentos.map(
                                                                                (p) => (
                                                                                    <tr key={p}>
                                                                                        <td className="left-align space-left">{p}</td>
                                                                                    </tr>
                                                                                )
                                                                            )}
                                                                        </tbody>
                                                                    </Table>
                                                                </td>
                                                                {pular.map((e) => (
                                                                    <td key={e.Plano}>
                                                                        <Table>
                                                                            <tbody>
                                                                                {e.Valores.map((v) => (
                                                                                    <tr key={v.Valor}>
                                                                                        <td>{formatarReal(v.Valor)}</td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </Table>
                                                                    </td>
                                                                ))}
                                                                {Array.from({ length: 7 - pular.length }).map((_, i) => (
                                                                    <td key={`empty-${i}`}></td>
                                                                ))}
                                                            </tr>
                                                        </tbody>
                                                    </Table>  </div></div>
                                        </div>))}
                                </div>

                            </div>
                        </>
                    )}

                    {this.state.ReembolsoCoeficienteMedicina && (
                        <div>
                            <div className="row container">
                                <div className="col s12 m12 l12">
                                    <h6>
                                        <b>Coeficiente Medicina: </b>
                                    </h6>
                                </div>
                            </div>

                            <div className="modalidadePlano">
                                <div className="row container planos">
                                    {cortarArray(
                                        this.state.ReembolsoCoeficienteMedicina.ReembolsosCoeficientes,
                                        7
                                    ).map((pular, index) => (
                                        <div>
                                            <div
                                                className="crop"
                                                id="ReembolsoCoeficiente"
                                                data-pdf-header="Coeficiente de Reembolso - Medicina"
                                            >
                                                <div className="row container planos">
                                                    <div className="ShowHiddenToDownload"><div className="PageHeaderSpace"></div></div>
                                                    <Table key={index}>
                                                        <thead>
                                                            <tr>
                                                                <td className="headerWithoutBackground"></td>
                                                                {pular.map((e) => (
                                                                    <td className="Header" key={e.Plano}>
                                                                        <b>{e.Plano}</b>
                                                                    </td>
                                                                ))}
                                                                {Array.from({ length: 7 - pular.length }).map((_, i) => (
                                                                    <td key={`empty-${i}`}></td>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <Table>
                                                                        <tbody>
                                                                            {this.state.ReembolsoCoeficienteMedicina.Eventos.map(
                                                                                (e) => (
                                                                                    <tr key={e}>
                                                                                        <td className="left-align space-left">{e}</td>
                                                                                    </tr>
                                                                                )
                                                                            )}
                                                                        </tbody>
                                                                    </Table>
                                                                </td>
                                                                {pular.map((e) => (
                                                                    <td key={e.Plano}>
                                                                        <Table>
                                                                            <tbody>
                                                                                {e.Valores.map((v) => (
                                                                                    <tr key={v.Valor}>
                                                                                        <td>{formatarRealcom4casas(v.Valor)}</td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </Table>
                                                                    </td>
                                                                ))}
                                                                {Array.from({ length: 7 - pular.length }).map((_, i) => (
                                                                    <td key={`empty-${i}`}></td>
                                                                ))}
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}


                    {this.state.ReembolsoCoeficienteOdonto && (
                        <div>
                            <div className="row container">
                                <div className="col s12 m12 l12">
                                    <h6>
                                        <b>Coeficiente Odonto: </b>
                                    </h6>
                                </div>
                            </div>

                            <div className="modalidadePlano">
                                <div
                                    className="crop"
                                    id="ReembolsoCoeficiente"
                                    data-pdf-header="Coeficiente de Reembolso - Odontologia"
                                >
                                    <div className="row container planos">
                                        {cortarArray(
                                            this.state.ReembolsoCoeficienteOdonto.ReembolsosCoeficientes,
                                            7
                                        ).map((pular, index) => (
                                            <div>

                                                <div className="row container planos">
                                                    <div className="ShowHiddenToDownload"><div className="PageHeaderSpace"></div></div>
                                                    <Table key={index} className="inverse-strep">
                                                        <thead>
                                                            <tr>
                                                                <td className="headerWithoutBackground"></td>
                                                                {pular.map((e) => (
                                                                    <td className="Header" key={e.Plano}>
                                                                        <b>{e.Plano}</b>
                                                                    </td>
                                                                ))}
                                                                {Array.from({ length: 7 - pular.length }).map((_, i) => (
                                                                    <td key={`empty-${i}`}></td>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <Table>
                                                                        <tbody>
                                                                            {this.state.ReembolsoCoeficienteOdonto.Eventos.map(
                                                                                (e) => (
                                                                                    <tr key={e}>
                                                                                        <td className="left-align space-left">{e}</td>
                                                                                    </tr>
                                                                                )
                                                                            )}
                                                                        </tbody>
                                                                    </Table>
                                                                </td>
                                                                {pular.map((e) => (
                                                                    <td key={e.Plano}>
                                                                        <Table>
                                                                            <tbody>
                                                                                {e.Valores.map((v) => (
                                                                                    <tr key={v.Valor}>
                                                                                        <td>{formatarRealcom4casas(v.Valor)}</td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </Table>
                                                                    </td>
                                                                ))}
                                                                {Array.from({ length: 7 - pular.length }).map((_, i) => (
                                                                    <td key={`empty-${i}`}></td>
                                                                ))}
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>


                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {this.state.RedeCredenciada && (
                        <>
                            <div className="row container">
                                <div className="col s12 m12 l12">
                                    <h6>
                                        <b>Exemplos de Rede Credenciada: </b>
                                    </h6>
                                </div>
                            </div>

                            <div className="modalidadePlano">
                                <div className="row container planos">
                                    {cortarArray(
                                        this.state.RedeCredenciada.RedesCredenciadas,
                                        7
                                    ).map((pular, index) => (
                                        <div>

                                            <div
                                                className="crop"
                                                id="ExemplosRedeCredenciada"
                                                data-pdf-header="Exemplos de Rede Credenciada"
                                            >
                                                <div className="ShowHiddenToDownload"><div className="PageHeaderSpace"></div></div>
                                                <div className="row container planos">

                                                    <Table key={index}>
                                                        <thead>
                                                            <tr>
                                                                <td className="headerWithoutBackground">
                                                                    <b>Principais Hospitais e Laboratórios</b>
                                                                </td>
                                                                {pular.map((r) => (
                                                                    <td className="Header" key={r.Plano}>
                                                                        <b>{r.Plano}</b>
                                                                    </td>
                                                                ))}
                                                                {Array.from({ length: 7 - pular.length }).map((_, i) => (
                                                                    <td key={`empty-${i}`}></td>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <Table>
                                                                        <tbody>
                                                                            {this.state.RedeCredenciada.Prestadores.map((p) => (
                                                                                <tr key={p}>
                                                                                    <td className="left-align space-left">{p}
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </Table>
                                                                </td>
                                                                {pular.map((r) => (
                                                                    <td className="credenciada" key={r.Plano}>
                                                                        <Table>
                                                                            <tbody>
                                                                                {r.Valores.map((v) => (
                                                                                    <tr key={v.Habilitado}>
                                                                                        <td>
                                                                                            {v.Habilitado}
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </Table>
                                                                    </td>
                                                                ))}
                                                                {Array.from({ length: 7 - pular.length }).map((_, i) => (
                                                                    <td key={`empty-${i}`}></td>
                                                                ))}
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>

                                        </div>

                                    ))}
                                </div>
                            </div>
                        </>)}

                    {this.state.RedeCobertura && (
                        <>
                            <div className="row container">
                                <div className="col s12 m12 l12">
                                    <h6>
                                        <b>Exemplos de cobertura: </b>
                                    </h6>
                                </div>
                            </div>
                            <div
                                className="crop"
                                id="CoberturasOdontologicas"
                                data-pdf-header="Principais coberturas"
                            >
                                <div className="modalidadePlano">
                                    <div className="row container planos">
                                        <div className="ShowHiddenToDownload"><div className="PageHeaderSpace"></div></div>
                                        {cortarArray(
                                            this.state.RedeCobertura.RedesCobertura,
                                            7
                                        ).map((pular, index) => (
                                            <Table key={index}>
                                                <thead>
                                                    <tr>
                                                        <td className="headerWithoutBackground">
                                                            <b>Principais Coberturas Odontológicas</b>
                                                        </td>
                                                        {pular.map((r) => (
                                                            <td className="Header" key={r.Plano}>
                                                                <b>{r.Plano}</b>
                                                            </td>
                                                        ))}
                                                        {Array.from({ length: 7 - pular.length }).map((_, i) => (
                                                            <td key={`empty-${i}`}></td>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <Table>
                                                                <tbody>
                                                                    {this.state.RedeCobertura.Prestadores.map((p) => (
                                                                        <tr c key={p}>
                                                                            <td className="left-align space-left">{p}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </td>
                                                        {pular.map((r) => (
                                                            <td className="credenciada" key={r.Plano}>
                                                                <Table>
                                                                    <tbody>
                                                                        {r.Valores.map((v) => (
                                                                            <tr key={v.Habilitado}>
                                                                                <td>{v.Habilitado}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </Table>
                                                            </td>
                                                        ))}
                                                        {Array.from({ length: 7 - pular.length }).map((_, i) => (
                                                            <td key={`empty-${i}`}></td>
                                                        ))}
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    {this.state.Coparticipacoes && (
                        <>
                            <div className="row container">
                                <div className="col s12 m12 l12">
                                    <h6>
                                        <b>Coparticipações: </b>
                                    </h6>
                                </div>
                            </div>
                            {this.state.mostrarColunasCoparticipacoes && (
                                <div className="modalidadePlano" data-pdf-header="Coparticipações">
                                    <div className="row container">
                                        <Table className="theadCoparticipacoes">
                                            <thead>
                                                <tr>
                                                    <td className="header-space-left headPlano">
                                                        <b>Plano</b>
                                                    </td>
                                                    <td className="header-space-left headAcesso">
                                                        <b>Acesso</b>
                                                    </td>
                                                    <td className="header-space-left headEvento">
                                                        <b>Evento</b>
                                                    </td>
                                                    <td className="header-space-left headPrestadores">
                                                        <b>Prestadores</b>
                                                    </td>
                                                    <td className="header-space-left headValorCopart">
                                                        <b>Valor Copart.</b>
                                                    </td>
                                                    <td className="header-space-left headValorLimite">
                                                        <b>Valor Limite</b>
                                                    </td>
                                                </tr>
                                            </thead>
                                        </Table>
                                    </div>
                                </div>
                            )}
                            {preencheLinhas(this.state.Coparticipacoes, 18).map((pular, index) => (
                                <div className="Coparticipacoes crop" id="Coparticipacoes" data-pdf-header="Coparticipações">
                                    <div className="modalidadePlano">
                                        <div className="row container">
                                            <div className="ShowHiddenToDownload"><div className="PageHeaderSpace"></div></div>
                                            <Table key={index}>
                                                <thead>
                                                    {!this.state.mostrarColunasCoparticipacoes && (
                                                        <tr>
                                                            <td className="header-space-left headPlano">
                                                                <b>Plano</b>
                                                            </td>
                                                            <td className="header-space-left headAcesso">
                                                                <b>Acesso</b>
                                                            </td>
                                                            <td className="header-space-left headEvento">
                                                                <b>Evento</b>
                                                            </td>
                                                            <td className="header-space-left headPrestadores">
                                                                <b>Prestadores</b>
                                                            </td>
                                                            <td className="header-space-left headValorCopart">
                                                                <b>Valor Copart.</b>
                                                            </td>
                                                            <td className="header-space-left headValorLimite">
                                                                <b>Valor Limite</b>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </thead>
                                                <tbody>
                                                    {pular.map((c, rowIndex) => (
                                                        <tr key={rowIndex}>
                                                            <td className="left-align space-left bodyPlano">{c.Plano}</td>
                                                            <td className="left-align space-left bodyAcesso">{c.Acesso}</td>
                                                            <td className="left-align space-left bodyEvento">{c.Evento}</td>
                                                            <td className="left-align space-left bodyPrestadores">{c.Prestadores}</td>
                                                            <td className="Valor left-align space-left bodyValorCopart">{parseFloat(c.Valor_Copart)}</td>
                                                            <td className="Valor left-align space-lef">
                                                                {c.Valor_Limite ? parseFloat(c.Valor_Limite) : "-"}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </>
                    )}

                    {this.state.Patologias && (
                        <>
                            <div className="row container">
                                <div className="col s12 m12 l12">
                                    <h6>
                                        <b>Patologias: </b>
                                    </h6>
                                </div>
                            </div>
                            <div className="crop" id="Patologias" data-pdf-header="Patologias">
                                <div className="modalidadePlano">
                                    <div className="row container">
                                        <div className="ShowHiddenToDownload"><div className="PageHeaderSpace"></div></div>
                                        <Table>
                                            <thead>
                                                <tr className="Patologias">
                                                    <td className="Patologias">
                                                        <b>CID</b>
                                                    </td>
                                                    <td className="Patologias">
                                                        <b>Vidas</b>
                                                    </td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.Patologias.map((p) => (
                                                    <tr className="Patologias">
                                                        <td className="Patologias">{p.Patologia_CID}</td>
                                                        <td className="Patologias">{p.Qtde_Vidas}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    {this.state.Observacoes && (
                        <>
                            <div className="row container">
                                <div className="col s12 m12 l12">
                                    <b>
                                        <h6>
                                            <b>Observações da proposta:</b>
                                        </h6>
                                    </b>
                                </div>
                            </div>
                            <div className="crop" id="Observacoes" data-pdf-header="Observações da proposta">
                                <div className="ShowHiddenToDownload"><div className="PageHeaderSpace"></div></div>
                                <div className="row container box">
                                    {this.state.Observacoes.map((o) => (
                                        <>
                                            <div className="description-divider">&nbsp;</div>
                                            <div className="col s1 m1 l1 center flow-text blue-text text-darken-2">
                                                {("0" + o.ordem).slice(-2)}.
                                            </div>
                                            <div className="col s11 m11 l11">{o.obs}</div>
                                        </>
                                    ))}
                                </div>

                                <div className="row container">
                                    <div className="col s7 m7 l7">

                                        <br />
                                        <br />

                                        {this.state.Rodape && (
                                            <div className="row">
                                                {this.state.Rodape.CM && (
                                                    <div className="col s12">
                                                        <b>{this.state.Rodape.CM}</b>
                                                    </div>
                                                )}
                                                {this.state.Rodape.CO && (
                                                    <div className="col s12">
                                                        <b>{this.state.Rodape.CO}</b>
                                                    </div>
                                                )}
                                            </div>)}
                                    </div>
                                </div>
                            </div>
                            <div className="row container"> <span id="ANSMARK" className="ANSMARKStatic">ANS - n.º 35966-1</span></div>
                        </>

                    )}

                </div>
            </div>
        );
    }
}
